import { ButtonGroup, ButtonText, Col, Dialog, DialogCardBody, DialogCardFooter, DialogCardHead, DialogCardHeadTitle, Grid, Row } from '@visa/vds';
import MCSReadonlyField from 'components/MCSReadonlyField';
import React, { useContext, useEffect, useState } from 'react';
import '../../pages/3DSStore/Subscriptions/EditSubscriptionStartDateDialog.css'
import { DateHelper } from '_helpers/DateHelper';
import DateSelector from '@visa/vds/date-selector';
import isValid from 'date-fns/isValid';
import { trackPromise } from 'react-promise-tracker';
import { SubscriptionApi } from 'services/subscription.service';
import { GlobalAlertContext } from 'context/GlobalAlertContext';
import MCSToolTip from 'components/MCSToolTip';
import { Label } from 'reactstrap';
import { useSetAuthContextUser, useAuthContext, useAuthContextUser } from 'context/AuthContext';

const EditVstsSubscriptionStartDateDialog = ({ fetchData, latestNonFutureSubscriptionEndDate, subscription, openEditVstsSubscriptionDialog, setOpenEditVstsSubscriptionDialog }) => {

    const ERROR_TEXT_REQUIRED_END_DATE = "Please select a new Start Date before proceeding."

    const duration = subscription.subscriptionName.includes("Base") ? 90 : 30
    const isExtensionSubscription = subscription.subscriptionName.includes("Extension") ? true : false
    const hasActiveSubscription = new Date(latestNonFutureSubscriptionEndDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) ? true : false

    const alertContext = useContext(GlobalAlertContext);
    const context = useAuthContext();
    const setUser = useSetAuthContextUser();

    const [showError, setShowError] = useState(false);
    const [errorText, setErrorText] = useState(ERROR_TEXT_REQUIRED_END_DATE)
    const [minDate, setMinDate] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);

    const handleWhenPageFirstLoads = () => {
        if (!isExtensionSubscription) {
            const today = new Date()
            today.setHours(0, 0, 0, 0)

            setMinDate(today);
            setSelectedDate(today)
            setSelectedStartDate(DateHelper.ToUTCDateTime(today))
            setSelectedEndDate(DateHelper.IncrementDate(today, duration, false, "dd MMM yyyy", true))
        }

        if (isExtensionSubscription) {
            const latestNonFutureSubscriptionEndDateZeroHours = latestNonFutureSubscriptionEndDate && latestNonFutureSubscriptionEndDate.setHours(0, 0, 0, 0)
            let endDatePlusNinetyDays = new Date(latestNonFutureSubscriptionEndDateZeroHours);
            endDatePlusNinetyDays.setDate(endDatePlusNinetyDays.getDate() + 90);
            setMaxDate(endDatePlusNinetyDays)

            if (hasActiveSubscription) {
                var canSelectDate = new Date(latestNonFutureSubscriptionEndDateZeroHours);
                canSelectDate.setDate(canSelectDate.getDate() + 1);

                setMinDate(canSelectDate);
                setSelectedDate(canSelectDate)
                setSelectedStartDate(DateHelper.ToUTCDateTime(canSelectDate))
                setSelectedEndDate(DateHelper.IncrementDate(canSelectDate, duration, false, "dd MMM yyyy", true))
            } else if (!hasActiveSubscription) {
                const today = new Date()
                today.setHours(0, 0, 0, 0)

                setMinDate(today);
                setSelectedDate(today)
                setSelectedStartDate(DateHelper.ToUTCDateTime(today))
                setSelectedEndDate(DateHelper.IncrementDate(today, duration, false, "dd MMM yyyy", true))
            }
        }
    }
    
    const handleConfirmEditBtn = () => {
        if (selectedStartDate == null) {
            setErrorText(ERROR_TEXT_REQUIRED_END_DATE)
            setShowError(true)
            return
        } else if (showError) return
        const subscriptionDto = {
            startDate: selectedStartDate,
            id: subscription.id,
            bid: subscription.bid
        }

        trackPromise(
            SubscriptionApi.UpdateVstsSubscriptionDates(subscriptionDto)
                .then(result => {
                    if (result.data.result.success) {
                        if (result.data.result.vstsAccess) {
                            context.user.navigation.vstsAccess = true;
                            setUser(context);
                        }
                        alertContext.setSuccessMessage("VSTS Subscription dates updated successfully.");
                    } else {
                        alertContext.setErrorMessage("VSTS Subscription dates updated failed. Please try again.");
                    }
                    setOpenEditVstsSubscriptionDialog(null);
                    fetchData(subscription.id);
                    setShowError(false);
                    setSelectedStartDate(null);
                    setSelectedEndDate(null);
                })
                .catch(error => { })
        )
    }

    const onSelectDate = (date) => {
        if (date != null) {
            setSelectedStartDate(DateHelper.ToUTCDateTime(date))
            setSelectedEndDate(DateHelper.IncrementDate(date, duration, false, "dd MMM yyyy", true))
            setShowError(false)
        }
    }

    useEffect(() => handleWhenPageFirstLoads(), [latestNonFutureSubscriptionEndDate, subscription])

    return (
        <>
            <Dialog
                aria-describedby="edit vsts start date"
                onExit={() => { }}
                open={openEditVstsSubscriptionDialog}
                titleId="amend vsts subscription"
            >
                <DialogCardHead>
                    <DialogCardHeadTitle id="dialog-title-manage-file">Edit VSTS Subscription Start Date</DialogCardHeadTitle>
                </DialogCardHead>

                <DialogCardBody id="dialog-description-manage-file-field">
                    <Grid>
                        <Row>
                            <Col>
                                <Row className="edit-vsts-start-date-label-row">
                                    <MCSReadonlyField
                                        label="VSTS Subscription"
                                    />
                                </Row>
                                <Row>
                                    {subscription.subscriptionName}
                                </Row>
                            </Col>
                        </Row>
                        <Row className="edit-vsts-dates-row">
                            <Col>
                                <Row className="edit-vsts-start-date-label-row">
                                    <MCSReadonlyField
                                        label="Start Date"
                                    />
                                </Row>
                                <Row>
                                    {DateHelper.ToFormattedDate(subscription.startDate)}
                                </Row>
                            </Col>
                            <Col>
                                <Row className="edit-vsts-start-date-label-row">
                                    <MCSReadonlyField
                                        label="End Date"
                                    />
                                </Row>
                                <Row>
                                    {DateHelper.ToFormattedDate(subscription.endDate)}
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{ width: "40px" }}>
                                <Row className="edit-vsts-start-date-label-row">
                                    <MCSReadonlyField
                                        label="New Start Date"
                                    />
                                    <div style={{ marginLeft: "-13px" }}>
                                        <MCSToolTip
                                            message="Future subscription cannot overlap with any current active subscription. If subscription is an extension subscription, start date must be within 90 days of previous subscription."
                                            iconName="info"
                                            placement="top"
                                        />
                                    </div>
                                </Row>
                                <Row>
                                    <DateSelector
                                        id="VSTS-end-date-input"
                                        ariaLabelCalendarButtonIcon={(date) => (
                                            isValid(new Date(date))
                                                ? `Choose new Start Date, selected Start date is ${date}`
                                                : 'Choose Start Date'
                                        )}
                                        name="date-picker-selected"
                                        showHelpText
                                        helpText="Click calendar icon to select date"
                                        showErrorText
                                        errorText={errorText}
                                        invalid={showError}
                                        minDate={minDate}
                                        selected={selectedDate}
                                        maxDate={maxDate}
                                        onSelect={date => onSelectDate(date)}
                                        formatInputValue='dd MMM yyyy'
                                    />
                                </Row>
                                {isExtensionSubscription && hasActiveSubscription &&
                                    <Row>
                                        <Label style={{ fontSize: "11px", lineHeight: "1.2" }}>{`Your current active subscription ends on ${DateHelper.ToFormattedDate(latestNonFutureSubscriptionEndDate)}. Please choose a date between ${DateHelper.ToFormattedDate(selectedDate)} and ${DateHelper.ToFormattedDate(maxDate)}.`}</Label>
                                    </Row>
                                }
                            </Col>
                            <Col>
                                <Row className="edit-vsts-start-date-label-row">
                                    <MCSReadonlyField style={{ border: "1px solid blue", marginLeft: "10px" }}
                                        label="New End Date"
                                    />
                                </Row>
                                <Row>
                                    {selectedEndDate && DateHelper.ToFormattedDate(selectedEndDate)}
                                    {!selectedEndDate && ""}
                                </Row>
                            </Col>
                        </Row>
                    </Grid>
                </DialogCardBody>
                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        <ButtonText
                            colorScheme="secondary"
                            onClick={() => {
                                setOpenEditVstsSubscriptionDialog(null);
                                setShowError(false);
                                setSelectedStartDate(selectedDate);
                                setSelectedEndDate(DateHelper.IncrementDate(selectedDate, duration, false, "dd MMM yyyy", true));
                            }}
                        >
                            Cancel
                        </ButtonText>
                        <ButtonText
                            colorScheme="primary"
                            onClick={() => {
                                handleConfirmEditBtn();
                            }}
                        >
                            Confirm
                        </ButtonText>
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>
    );
};

export default EditVstsSubscriptionStartDateDialog;